import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Creatable } from 'react-select';
import _ from 'lodash';

const mapActionCreators = {};

const mapStateToProps = state => ({
  companies: state.company.companies,
});

class CompanyPicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.default,
    };
  }

  setValue = value => {
    this.setState({ value });

    let val = null;

    if (value !== null) {
      if (typeof value.length !== 'undefined') {
        val = value.map(val => val.value);
      } else {
        val = value.value;
      }
    }

    this.props.onChange({
      target: {
        name: this.props.name,
        value: val,
        rawValue: value,
      },
    });
  };

  render() {
    const props = this.props;

    const placeholder = <span>Unternehmen wählen</span>;
    const allData = props.companies;
    const multi = props.multi;
    const selectData = [];

    _.forOwn(allData, data => {
      if (data.deleted_at === null) {
        selectData.push({
          value: data.id,
          title: data.name,
          label: data.name,
        });
      }
    });

    return (
      <div className="section">
        <Creatable
          onChange={this.setValue}
          options={selectData}
          placeholder={placeholder}
          multi={multi}
          value={this.state.value}
          promptTextCreator={label => `Neues Unternehmen erstellen: ${label}`}
          clearable={
            typeof props.clearable !== 'undefined' ? props.clearable : true
          }
        />
      </div>
    );
  }
}
CompanyPicker.propTypes = {
  name: PropTypes.string,
  multi: PropTypes.bool,
  default: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  onChange: PropTypes.func,
};

CompanyPicker.defaultProps = {
  multi: false,
};

export default connect(mapStateToProps, mapActionCreators)(CompanyPicker);



// WEBPACK FOOTER //
// ./src/components/CompanyPicker/CompanyPicker.js